import React from 'react';
export function IntroContent() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3144">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3145">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border mb-12" style={{
        borderColor: '#ede9e0'
      }} data-id="element-3146">
          <p className="text-lg font-medium text-gray-900 mb-6 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3147">
            Safety experts agree the single most important factor in surviving a
            criminal attack is to have a personal safety strategy in place
            before it is needed. The Refuse To Be A Victim® crime prevention
            seminar, a program of the National Rifle Association, is pleased to
            offer this easy-to-understand personal safety information at the
            Fenton Lakes Sportsman's Club.
          </p>
          <p className="text-base text-gray-800 leading-relaxed" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3148">
            Refuse To Be A Victim® is a seminar full of crime prevention and
            personal safety strategies you can use to develop your own safety
            plan. In just four hours you will learn about home, automobile,
            phone, technology, personal safety—and much more.
          </p>
        </div>
      </div>
    </div>;
}